import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { UserContex } from '../context API/UserContext';

const AddContact = () => {
     const [address, setAddress] = useState("");
     const [email, setEmail] = useState("");
     const [phone, setPhone] = useState();
     const [telegram, setTelegram] = useState("");
      const [userData, setUserData] = useContext(UserContex);
     const navigate=useNavigate()
     console.log(email)
     const handlesubmit=(e)=>{
        e.preventDefault()
        axios
          .post("https://back.waratechnology.com/api/contact/setcontact", {
            address,
            email,
            phone,
            telegram,
          })
          .then((res) => {
            console.log(res.data.msg);
            navigate("/contact");
          })
          .catch((err) => {
            console.log(err);
          });
     }
     useEffect(() => {
       if (!userData.user) {
         navigate("/login");
       }
     });
  return (
    <div className="bg-gray-400  flex justify-center items-center h-screen pt-12 ">
      <div className="w-3/4 h-3/4 md:w-1/2 md:h-3/4 bg-white  border border-black-1 border-rounded rounded-2xl p-4 shadow-lg shadow-white-500/50 ">
        <div className="flex justify-center mt-2 mb-4">
          <h1 className="uppercase font-bold text-2xl">Add Contact</h1>
        </div>
        <form onSubmit={handlesubmit} className="grid grid-cols-1 gap-4">
          <div className='flex '>
            <label className="font-bold mr-2">Address</label>
            <input
              placeholder="address"
              type="text"
              className="w-full py-2  pl-2 h-12 md:h-8 mb-4 border border-gray-300 rounded-2xl"
              onChange={(e) => setAddress(e.target.value)}
            />
          </div>
          <div className='flex'>
            <label className="font-bold mr-2">Email</label>
            <input
              placeholder="email"
              type="email"
              className="w-full py-2 h-12 md:h-8 pl-2 border border-gray-300 rounded-2xl"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className='flex'>
            <label className="font-bold mr-2">Phone</label>
            <input
              placeholder="phone"
              type="number"
              className="w-full py-2 h-12 md:h-8 pl-2 border border-gray-300 rounded-2xl"
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>
          <div className='flex'>
            <label className="font-bold mr-2">Telegram</label>
            <input
              placeholder="telegram"
              type="text"
              className="w-full py-2 h-12 md:h-8 pl-2 border border-gray-300 rounded-2xl"
              onChange={(e) => setTelegram(e.target.value)}
            />
          </div>

          <div className="flex justify-center mt-4">
            <button
              type=""
              className="uppercase bg-red-500 mt-4 text-white px-4 py-1 rounded rounded-fully"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddContact
